import React, { Fragment, useEffect, useRef } from "react";
import { useState } from "react";
import NavCustomizer from "./NavCustomizer";
import TabCustomizer from "./TabCustomizer";
import axios from "../../axios/axios";
import { useDispatch } from "react-redux";
import { selectUser, setIsGroup, setNotiTotalCount, setUsers } from "../../utils/userSlice";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const Themecustomizer = () => {
  const baseurl = useSelector((store) => store.baseUrl);
  // const [selected, setSelected] = useState("check-layout");
  const [openCus, setOpenCus] = useState(false);
  const [userdetails, setUserdetails] = useState(
    JSON.parse(localStorage.getItem("userdetails"))
  );
  const notificationCount = useSelector(
    (state) => state?.users?.notiTotalCount
  );
  const dispatch = useDispatch();

  // Ref to track the latest notification count
  const notificationCountRef = useRef(notificationCount);

  // Keep the ref updated with the latest notification count
  useEffect(() => {
    notificationCountRef.current = notificationCount;
  }, [notificationCount]);
  // const callbackNav = (select, open) => {
  //   setSelected(select);
  //   setOpenCus(open);
  // };

  useEffect(() => {
    fetchEmployeeList();
    // fetchAllNotificationsCount(userdetails);
  }, []);

  useEffect(() => {
   
    // fetchEmployeeList();
    // Set up polling every 5 seconds
    if (process.env.REACT_APP_IS_POS == '0') {
      const pollingInterval = setInterval(() => {
        fetchAllNotificationsCount(userdetails);
        fetchEmployeeListApipoll();
      }, 8000);
  
      // Clean up on unmount or when selectedUserr changes
      return () => clearInterval(pollingInterval);
    }
   
  }, []);

  const fetchEmployeeList = async () => {
    const formData = new FormData();
    formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
    formData.append("PHPTOKEN", localStorage.getItem("id_token"));
    formData.append("user_id", userdetails?.employee_id);
    formData.append("get_group", "Y");
    formData.append("user_type", userdetails?.user_type);

    try {
      const response = await fetch(`${baseurl}/common_api/getemployee_list/`, {
        method: "POST",
        body: formData,
      });
      const result = await response.json();

      if (result[0]?.STATUS == "SUCCESS") {
        const employeeArr = result[0]?.DATA?.employee_arr;
        dispatch(setUsers(employeeArr));
         const firstGroup = employeeArr.find((item) => item.group_id) || employeeArr[0] || {};
        dispatch(selectUser(firstGroup));
        dispatch(setIsGroup(!!firstGroup.group_id)); // Set isGroup based on whether a group was found
      } else {
        console.error("Failed to fetch employee list:", result[0]?.MESSAGE);
        dispatch(setUsers([]));
        dispatch(selectUser({}));
      }
    } catch (error) {
      console.error("Error fetching employee list:", error.message);
      dispatch(setUsers([]));
      dispatch(selectUser({}));
    }
  };

  const fetchEmployeeListApipoll = async () => {
    const formData = new FormData();
    formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
    formData.append("PHPTOKEN", localStorage.getItem("id_token"));
    formData.append("user_id", userdetails?.employee_id);
    formData.append("get_group", "Y");
    formData.append("user_type", userdetails?.user_type);

    try {
      const response = await fetch(`${baseurl}/common_api/getemployee_list/`, {
        method: "POST",
        body: formData,
      });
      const result = await response.json();

      if (result[0]?.STATUS == "SUCCESS") {
        const employeeArr = result[0]?.DATA?.employee_arr;
        dispatch(setUsers(employeeArr));
        // dispatch(selectUser(employeeArr[0]));
      } else {
        console.error("Failed to fetch employee list:", result[0]?.MESSAGE);
        // dispatch(setUsers([]));
        // dispatch(selectUser({}));
      }
    } catch (error) {
      console.error("Error fetching employee list:", error.message);
      // dispatch(setUsers([]));
      // dispatch(selectUser({}));
    }
  };
  

  // Function to play notification sound
  const playNotificationSound = () => {
    const audio = new Audio(
      `${baseurl}/public/images/supportportal/noti-sound.mp3`
    ); // Path to your notification sound

    try {
      audio.play().catch((error) => {
        // Handle the error silently
        console.warn("Notification sound play failed:", error.message);
      });
    } catch (error) {
      // Handle any unexpected errors
      console.error("Error playing notification sound:", error.message);
    }
  };

  const fetchAllNotificationsCount = async (userdetails) => {
    const formData = new FormData();
    formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
    formData.append("PHPTOKEN", localStorage.getItem("id_token"));
    formData.append("user_id", userdetails?.employee_id);
    formData.append("user_type", userdetails?.user_type);

    try {
      const response = await fetch(
        `${baseurl}/common_api/get_user_unread_message/`,
        {
          method: "POST",
          body: formData,
        }
      );
      const result = await response.json();
      if (result[0]?.STATUS == "SUCCESS") {
        const totalnoticount = result[0]?.total_count;

        // Compare the current notification count with the fetched count
        if (notificationCountRef.current != totalnoticount) {
          if (notificationCountRef.current < totalnoticount) {
            toast.success("New message arrived!", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });

            // Play notification sound when new message is received
            playNotificationSound();
          }
          dispatch(setNotiTotalCount(totalnoticount)); // Dispatch only if counts are different
        }
      } else {
        console.error("Failed to fetch notifications:", result[0]?.MESSAGE);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error.message);
    }
  };

  return (
    <Fragment>
      <div className={`customizer-links ${openCus ? "open" : ""}`}>
        {/* <NavCustomizer callbackNav={callbackNav} selected={selected} /> */}
      </div>
      <div className={`customizer-contain ${openCus ? "open" : ""}`}>
        {/* <TabCustomizer selected={selected} callbackNavTab={callbackNav} /> */}
      </div>
    </Fragment>
  );
};

export default Themecustomizer;
